/**
 * @generated SignedSource<<26953e9dec78044a229ec6efe64b64d3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RenderChildRowsComp$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Rows_project">;
  readonly " $fragmentType": "RenderChildRowsComp";
};
export type RenderChildRowsComp$key = {
  readonly " $data"?: RenderChildRowsComp$data;
  readonly " $fragmentSpreads": FragmentRefs<"RenderChildRowsComp">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "RenderChildRowsComp",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Rows_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "b22d740a214bd50022d2b05cb96bd804";

export default node;
